import { Form, InputGroup, Button } from "react-bootstrap";
import { extractNumbers } from "utils/input.util";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "./PhoneInputStep.css";

const PhoneInputStep = ({ formik, defaultCountry, isISE2Flow }) => {
  const { t } = useTranslation();

  function getSelectedDropdownItem(country) {
    return (
      <>
        <img src={`https://flagcdn.com/${country.isoCode}.svg`} width="24" alt={country.name} />
        <span>{country.dialCode}</span>
      </>
    );
  }

  return (
    <>
      <div className="login-thumbnail2">
        <img src="/image/login_img.png" alt="login" />
      </div>
      <div className="phone-input">
        <h3 className="login-title my-3 text-center">{t("51")}</h3>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group>
            {!isISE2Flow && (
              <InputGroup className="has-validation">
                <div className="dialing-code">{getSelectedDropdownItem(defaultCountry)}</div>
                <Form.Control
                  id="mobileNumber"
                  name="mobileNumber"
                  type="text"
                  placeholder={t("81")}
                  onChange={(e) =>
                    formik.setFieldValue("mobileNumber", extractNumbers(e.currentTarget?.value, 10))
                  }
                  onBlur={formik.handleBlur}
                  value={formik.values.mobileNumber}
                  isInvalid={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                />
                <Form.Control.Feedback type="invalid">
                  {t(formik.errors.mobileNumber)}
                </Form.Control.Feedback>
              </InputGroup>
            )}
            <InputGroup className="has-validation">
              <Form.Check id="isTncAccepted" name="isTncAccepted" className="my-1">
                <Form.Check.Input
                  type="checkbox"
                  className="border border-primary"
                  checked={formik.values.isTncAccepted}
                  value={formik.values.isTncAccepted}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <Form.Check.Label>
                  <Link to="/tnc" className="info">
                    {t("106")}
                  </Link>
                </Form.Check.Label>
              </Form.Check>
            </InputGroup>
            <Button
              type="submit"
              variant="primary"
              className="w-100"
              disabled={!formik.isValid || formik.isSubmitting || !formik.values.isTncAccepted}
            >
              {t("80")}
            </Button>
          </Form.Group>
        </Form>
      </div>
    </>
  );
};

export default PhoneInputStep;
